.root {
  -webkit-appearance: none;
  appearance: none;
  background: linear-gradient(
    to right,
    var(--color-primary) 0%,
    var(--color-primary) var(--fill, 0%),
    var(--color-border) var(--fill, 0%),
    var(--color-border) 100%
  );
  border-radius: 999px;
  cursor: pointer;
  height: 6px;
  margin: 0;
  width: 100%;
}

.root-is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.root::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  background: var(--color-surface);
  border: 2px solid var(--color-primary);
  border-radius: 50%;
  cursor: pointer;
  height: 16px;
  width: 16px;
}

.root::-moz-range-thumb {
  background: var(--color-surface);
  border: 2px solid var(--color-primary);
  border-radius: 50%;
  cursor: pointer;
  height: 16px;
  width: 16px;
}
